import { Guide, Tour } from "@agp/shared.user-app/entity";
import { useCallback, useState } from "react";
import { MonotoneGuideListItem } from "../components/monotone-guide-list-item";
import ServiceLocator from "../../../../domain/service-locator";
import { useLanguageBasedFont } from "../const/font-utils";

type MonotoneTourContainerProps = {
  tour: Tour;
  guides: Guide[];
};

export const MonotoneTourContainer = (props: MonotoneTourContainerProps) => {
  const { tour, guides } = props;
  const guidePlayerModule = ServiceLocator.GuidePlayerModule;
  const [isImageLoading, setIsImageLoading] = useState(true);
  const fontClass = useLanguageBasedFont();
  const currentTrack = guidePlayerModule.currentTrack.watch();
  const isPlaying = guidePlayerModule.isPlaying.watch();
  const layoutModule = ServiceLocator.PlayerLayoutModule;

  const handleClickGuide = useCallback(
    (guide: Guide, isPlusIcon: boolean) => {
      if (guidePlayerModule.currentTrack.value?.id === guide.id) {
        return;
      }

      if (isPlusIcon) layoutModule.playerType.setValue("full");

      guidePlayerModule.select(guide.id);
      guidePlayerModule.play();
    },
    [guidePlayerModule]
  );

  const handleImageLoad = useCallback(() => {
    setIsImageLoading(false);
  }, []);

  const handleImageError = useCallback(() => {
    setIsImageLoading(false);
  }, []);

  return (
    <div className={`flex flex-col ${fontClass}`}>
      <div className={"p-2 flex flex-col"}>
        <div className={"relative w-full rounded-3xl overflow-hidden"}>
          {tour.thumbnailUrls && tour.thumbnailUrls.length > 0 && (
            <div className={"mt-12"}>
              {isImageLoading && (
                <div
                  className={
                    "w-full h-[280px] rounded-3xl bg-gray-200 animate-pulse"
                  }
                />
              )}
              <img
                className={`w-full rounded-3xl bg-gray-200 flex justify-center items-center text-2xl ${
                  isImageLoading
                    ? "opacity-0 absolute top-0 left-0"
                    : "opacity-100"
                }`}
                src={tour.thumbnailUrls[0]}
                alt={tour.name}
                onLoad={handleImageLoad}
                onError={handleImageError}
              />
            </div>
          )}
        </div>
        {/* MEMO: ルックバック展に向けた暫定対応、一時的にエリア説明を非表示に */}
        {/* <div
          className={twMerge(
            `${fontClass} text-[18px] font-bold`,
            guides.length > 0 ? "text-[16px]" : "text-[18px]"
          )}
        >
          {tour.name}
        </div> */}
      </div>
      {guides.length > 0 && (
        <div className={"mt-2 flex flex-col gap-5"}>
          {guides
            .sort((a, b) => a.trackNumber - b.trackNumber)
            .map((guide) => (
              <>
                <MonotoneGuideListItem
                  guide={guide}
                  onClickGuide={(g) => handleClickGuide(g, false)}
                  onClickPlusIcon={(g) => handleClickGuide(g, true)}
                  key={guide.id}
                  isSelected={currentTrack?.id === guide.id}
                  isListening={isPlaying && currentTrack?.id === guide.id}
                />
                <div className={"h-[0.71px] w-full bg-[#808080] mb-2"} />
              </>
            ))}
        </div>
      )}
    </div>
  );
};
